import { Item } from '@sitecore-jss/sitecore-jss-nextjs';

export type PlanType = {
  id: string;
  name: string;
  fields: {
    name: string;
    planOptionsListingPage: Item;
    planSearchPage: Item;
    planDetailPage: Item;
    planComparePage: Item;
  };
};
